const Acerca = () => {
  return (
    <div>
      <h3>Acerca</h3>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut eum facilis
        velit veniam harum molestias placeat illo, odio ea facere quod nihil
        veritatis nobis cupiditate, fuga eius maxime. Quis, similique.
      </p>
    </div>
  );
};

export default Acerca;
